function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.array.slice.js";
import { useMemo } from 'react';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import { request } from '@applyboard/ui-utils';
import { toCamelCase } from "../util/common";
var modifiedQuestionsToObject = function modifiedQuestionsToObject(modifiedQuestions) {
  return modifiedQuestions.map(function (modifiedQuestion) {
    return {
      question: modifiedQuestion[0],
      questionFormat: modifiedQuestion[1],
      answerOptions: modifiedQuestion[2]
    };
  });
};
var attributesToCamelCase = function attributesToCamelCase(attributes) {
  var camelizedAttributes = attributes.map(function (element) {
    element['attribute'] = toCamelCase(element['attribute']);
    return element;
  });
  return camelizedAttributes;
};
var transformModifiedAttributes = function transformModifiedAttributes(attributes) {
  return attributesToCamelCase(attributes).map(function (modifiedAttribute) {
    var newModifiedAttribute = _objectSpread({}, modifiedAttribute);
    if (modifiedAttribute.attribute === 'questions') {
      newModifiedAttribute.instance = modifiedQuestionsToObject(modifiedAttribute.instance);
      newModifiedAttribute.template = modifiedQuestionsToObject(modifiedAttribute.template);
    }
    return newModifiedAttribute;
  });
};
function transformRequirementDifferences(requirementDifference) {
  var _relationships$applic, _relationships$requir;
  var attributes = requirementDifference.attributes,
    relationships = requirementDifference.relationships;
  var applicationRequirement = (_relationships$applic = relationships.application_requirement) === null || _relationships$applic === void 0 ? void 0 : _relationships$applic.data;
  return {
    applicationId: attributes.application_id,
    applicationRequirementId: applicationRequirement === null || applicationRequirement === void 0 ? void 0 : applicationRequirement.id,
    applyAutomatically: attributes.apply_automatically,
    category: attributes.category,
    differenceType: attributes.difference_type,
    currentStage: attributes.current_stage,
    description: attributes.description,
    entityLevelId: null,
    finalStage: attributes.final_stage,
    id: requirementDifference.id,
    classification: attributes.classification,
    isEarlyAccess: attributes.is_early_access,
    requirementTemplateId: (_relationships$requir = relationships.requirement_template) === null || _relationships$requir === void 0 ? void 0 : _relationships$requir.data.id,
    stage: attributes.stage,
    status: attributes.status,
    title: attributes.title,
    modifiedAttributes: transformModifiedAttributes(attributes.modified_attributes),
    tags: attributes.tags
  };
}
function transformRequirementDifferencesMeta(original) {
  return {
    totalCount: original.total_count,
    appReqCount: original.app_req_count,
    actionsCount: original.actions_count
  };
}
function getIncludedFields(extraFields) {
  var extraFieldsSet = new Set(extraFields);
  var includedFields = [];
  if (extraFieldsSet.has('entityLevelId')) {
    includedFields.push('application_requirement');
  }
  return includedFields;
}
function getRequirementDifferencesEndpoint(applicationId, extraFields) {
  var apiFieldSelectors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var included = '';
  if (extraFields.length !== 0) {
    included = "include=".concat(getIncludedFields(extraFields).join());
  }
  var applicationRequirementFields = [
  // relationships
  'entity_level',
  // attributes
  'applyboard_requirement', 'applyproof_compatible', 'completed_at', 'created_with_condition', 'deadline', 'description', 'internal', 'internal_description', 'internal_title', 'official', 'optional', 'required_state', 'status', 'title', 'updated_at'].join(',');
  var defaultApiFieldSelectors = {
    'fields[application_questions_requirement]': applicationRequirementFields,
    'fields[application_document_requirement]': applicationRequirementFields,
    'fields[application_receipt_requirement]': applicationRequirementFields,
    'fields[application_payment_requirement]': applicationRequirementFields,
    'fields[application_disclaimer_requirement]': applicationRequirementFields
  };
  var fieldSelectors = new URLSearchParams(_objectSpread(_objectSpread({}, defaultApiFieldSelectors), apiFieldSelectors)).toString();
  return "/api/applications/".concat(applicationId, "/requirement_differences?").concat(included, "&").concat(fieldSelectors);
}
var emptyData = {
  data: [],
  meta: {
    total_count: 0,
    app_req_count: 0,
    actions_count: 0
  }
};
function fetchRequirementDifferences(_x, _x2) {
  return _fetchRequirementDifferences.apply(this, arguments);
}
function _fetchRequirementDifferences() {
  _fetchRequirementDifferences = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(applicationId, extraFields) {
    var endpointUrl, res;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (applicationId) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", emptyData);
        case 2:
          endpointUrl = getRequirementDifferencesEndpoint(applicationId, extraFields);
          _context2.next = 5;
          return request(endpointUrl, {
            defaultResponse: {
              data: [],
              meta: {
                total_count: 0,
                app_req_count: 0,
                actions_count: 0
              }
            },
            isExpectedResponse: isExpectedResponse //eslint-disable-line no-restricted-syntax
          });
        case 5:
          res = _context2.sent;
          return _context2.abrupt("return", res);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _fetchRequirementDifferences.apply(this, arguments);
}
export function useRequirementDifferences(_ref) {
  var applicationId = _ref.applicationId,
    _ref$extraFields = _ref.extraFields,
    extraFields = _ref$extraFields === void 0 ? [] : _ref$extraFields;
  var _useQuery = useQuery(['requirement_differences', {
      applicationId: applicationId,
      extraFields: extraFields
    }], function () {
      return fetchRequirementDifferences(applicationId, extraFields);
    }, {
      refetchOnWindowFocus: false
    }),
    isLoading = _useQuery.isLoading,
    error = _useQuery.error,
    data = _useQuery.data,
    isFetching = _useQuery.isFetching;
  var responseData = useMemo(function () {
    if (data == null) return [];
    var requirementDifferenceData = data.data;
    return requirementDifferenceData.map(function (dataItem) {
      return transformRequirementDifferences(dataItem);
    });
  }, [data]);
  var responseMeta = useMemo(function () {
    return _typeof(data === null || data === void 0 ? void 0 : data.meta) === 'object' ? transformRequirementDifferencesMeta(data === null || data === void 0 ? void 0 : data.meta) : {};
  }, [data === null || data === void 0 ? void 0 : data.meta]);
  return {
    isLoadingRequirementDifferences: isLoading,
    isFetchingRequirementDifferences: isFetching,
    requirementDifferencesError: error,
    requirementDifferences: responseData,
    requirementDifferencesMeta: responseMeta
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isExpectedResponse(res) {
  return res && _typeof(res) === 'object' && Array.isArray(res.data);
}
function fetchUpdateRequirementDifferences(_x3, _x4, _x5) {
  return _fetchUpdateRequirementDifferences.apply(this, arguments);
}
function _fetchUpdateRequirementDifferences() {
  _fetchUpdateRequirementDifferences = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(applicationId, newRequirementIds, unneededRequirementIds) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (applicationId) {
            _context3.next = 2;
            break;
          }
          throw {
            body: {}
          };
        case 2:
          _context3.next = 4;
          return request("/api/applications/".concat(applicationId, "/update_requirements"), {
            method: 'PATCH',
            body: {
              _jsonapi: {
                new_requirements: newRequirementIds,
                unneeded_requirements: unneededRequirementIds
              }
            },
            // eslint-disable-next-line no-restricted-syntax -- TODO: Refactor this to use `schema`
            isExpectedResponse: function isExpectedResponse() {
              return true;
            },
            throwError: function throwError(res) {
              throw res;
            }
          });
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _fetchUpdateRequirementDifferences.apply(this, arguments);
}
export function useUpdateRequirementDifferences() {
  var _useMutation = useMutation( /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
        var applicationId, newRequirementIds, unneededRequirementIds;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              applicationId = _ref2.applicationId, newRequirementIds = _ref2.newRequirementIds, unneededRequirementIds = _ref2.unneededRequirementIds;
              _context.next = 3;
              return fetchUpdateRequirementDifferences(applicationId, newRequirementIds, unneededRequirementIds);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x6) {
        return _ref3.apply(this, arguments);
      };
    }()),
    mutate = _useMutation.mutate;
  return {
    updateRequirementDifferences: mutate
  };
}
export function useReloadRequirementDifferences() {
  var queryClient = useQueryClient();
  var invalidateQuery = function invalidateQuery() {
    queryClient.invalidateQueries('requirement_differences');
  };
  return {
    reloadRequirementDifferences: invalidateQuery
  };
}